var W_width = $(window).width(), W_height = $(window).height();
$(window).on('resize', function () {
  if($(window).width() != W_width || $(window).height() != W_height){
    W_width = $(window).width();
    W_height = $(window).height();
  	_initResize();
  }
});
$(window).on('load', function () {
  _initResize();
});

// Filters
function _initResize() {

  //initSwatches();
  $('.filter-refine').off('click');
  $('.filter-overlay, .filter__close, .filter__apply').off('click');
  $('.filter-sort__title').off('click');
  $(document).off('click.resize');
  $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
  $('.filters__container').removeClass('filters__container--sticky');
  $('html').removeClass('no-scroll');
  $('.filter-sort__list').css('display','');
  $('.filter-sort').off('click');
  // Filters Mobile/Tablet
if ($(window).width() < 1365) {
  // Filters - Open
  $('.filter-refine').on('click', function () {
    $('.filter').toggleClass('filter--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('.filter-overlay').addClass('filter-overlay--active');
    $('html').addClass('no-scroll');
    return false;
  });

  // Filter - Close
  $('.filter-overlay, .filter__close, .filter__apply').on('click', function () {
    $('.filter').removeClass('filter--active');
    $('.filter-overlay').removeClass('filter-overlay--active');
    $('html').removeClass('no-scroll');
    return false;
  });

}

// Sort Tablet/Desktop
if ($(window).width() > 599) {
  $('.filter-sort__title').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter-sort__list--active')) {
      $this.next().removeClass('filter-sort__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter-sort .filter-sort__list').removeClass('filter-sort__list--active');
      $this.parent().parent().find('.filter-sort .filter-sort__list').slideUp(150);
      $this.next().toggleClass('filter-sort__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter-sort__title--active')) {
      $this.removeClass('filter-sort__title--active');
    } else {
      $this.parent().find('.filter-sort .filter__title').removeClass('filter-sort__title--active');
      $this.toggleClass('filter-sort__title--active');
    }

  });

  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort__title').removeClass('filter-sort__title--active');
      $('.filter-sort__list').slideUp(150);
    }
  }); 
}

// Sort Mobile
if ($(window).width() < 600) {
  $('.filter-sort').on('click', function () {    
    $(this).children('.filter-sort__list').toggleClass('filter-sort__list--active');
    $('.filter-sort-overlay').toggleClass('filter-sort-overlay--active');
    $('.filters__container').removeClass('filters__container--sticky');
    $('html').toggleClass('no-scroll');
    return false;
  });
  $(document).on('click.resize',function (e) {
    if (!$(e.target).is(".filter-sort *") && !$(e.target).is(".filter__group *")) {
      $('.filter-sort__list').removeClass('filter-sort__list--active');
      $('.filter-sort-overlay').removeClass('filter-sort-overlay--active');
      $('html').removeClass('no-scroll');
      
    }
  }); 
}
previousScroll = 0;
headerOrgOffset = 0;
if ($(window).width() > 1365) {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top + 28-$(document).scrollTop();
} else {
  if ($('.header').length>0)  headerOrgOffset = $('.header').offset().top-$(document).scrollTop();
}
  
};
// Filters All
$(document).ready(function() {

 _initFilter();

  $(document).click(function (e) {
    if (!$(e.target).is(".filter__group *")) {
      $('.filter__list').removeClass('filter__list--active');
      $('.filter__title').removeClass('filter__title--active');
      $('.filter__list').slideUp(150);
    }
  });
});


function _initFilter() {
   // Filter - Accordion
  $('.filter__title').off('click').on('click',function(e) {
    e.preventDefault();
  
    var $this = $(this);
  
    if ($this.next().hasClass('filter__list--active')) {
      $this.next().removeClass('filter__list--active');
      $this.next().slideUp(150);
    } else {
      $this.parent().parent().find('.filter__group .filter__list').removeClass('filter__list--active');
      $this.parent().parent().find('.filter__group .filter__list').slideUp(150);
      $this.next().toggleClass('filter__list--active');
      $this.next().slideToggle(150);
    }

    if ($this.hasClass('filter__title--active')) {
      $this.removeClass('filter__title--active');
    } else {
      $this.parent().find('.filter__group .filter__title').removeClass('filter__title--active');
      $this.toggleClass('filter__title--active');
    }

  });


}
// Canvas Cart
var dataOffcanvas;
$(document).ready(function() { 
  $( function(){

    $( document ).on( "beforecreate.offcanvas", function( e ){
      dataOffcanvas = $( e.target ).data('offcanvas-component');
      console.log(dataOffcanvas);
      dataOffcanvas.onInit =  function() {
        console.log(this);
      };
    } );

    $( document ).on( "create.offcanvas", function( e ){
      var dataOffcanvas = $( e.target ).data('offcanvas-component');
      console.log(dataOffcanvas.options);
      dataOffcanvas.onOpen =  function() {
        console.log('Callback onOpen');
      };
      dataOffcanvas.onClose =  function() {
        console.log('Callback onClose');
      };
    } );

    $( document ).on( "clicked.offcanvas-trigger clicked.offcanvas", function( e ){
      var dataBtnText = $( e.target ).text();
      console.log(e.type + '.' + e.namespace + ': ' + dataBtnText);
    } );

    $( document ).on( "open.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
      console.log(e.type + ': #' + dataOffcanvasID);
    } );

    $( document ).on( "resizing.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
      console.log(e.type + ': #' + dataOffcanvasID);
    } );

    $( document ).on( "close.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
      console.log(e.type + ': #' + dataOffcanvasID);
    } );

    $( document ).on( "destroy.offcanvas", function( e ){
      var dataOffcanvasID = $( e.target ).attr('id');
      console.log(e.type + ': #' + dataOffcanvasID);
    } );

    $( '#bottom' ).on( "create.offcanvas", function( e ){
      var api = $(this).data('offcanvas-component');

      console.log(api);
      $('.js-destroy').on('click', function () {
        api.destroy();
        //$( '#top' ).data('offcanvas-component').destroy();
        console.log(api);
        console.log( $( '#top' ).data() );
      });
    } );

    $( '#left' ).offcanvas( {
      modifiers: "left,overlay",
      triggerButton: '.js-offcanvas-trigger-left'
    } );

    $('.js-enhance').on('click', function () {
      console.log('enhance');
      $( document ).trigger( "enhance" );
    });

    $( document ).trigger( "enhance" );
  });
});

// Filter Switch
function setCookie(cname,cvalue) {
  var d = new Date();
  d.setTime(d.getTime() + (365*24*60*60*1000));
  var expires = "expires=" + d.toGMTString();
  if((typeof cvalue)!="string")   var cvalue_string=JSON.stringify(cvalue);
  else var cvalue_string=cvalue;
  document.cookie = cname + "=" + cvalue_string + ";" + expires + ";path=/";
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  } 
}

var layouts={
  desktop:[4,3],
  tablet:[3,2],
  mobile:[2,1]
}

function getWindowLayout() {
  var _windowWidth=jQuery(window).width();
  if ( _windowWidth< 767) {
    return layouts.mobile;
  }
  else if (_windowWidth < 1024) {
    return layouts.tablet;
  }
  else {
    return layouts.desktop;
  }
}

function switchLayout(isFirst,isNext) {
  var perRow=1;
  if (isFirst===true) {
    var _perCookie= getCookie("perrow");
    if (_perCookie!=undefined) perRow=parseInt(_perCookie);
  }
  var currentPerRow=$('.filter-switch__grid').get(0).className.match(/show(\d)/);
  if (currentPerRow!=null) {
    perRow=parseInt(currentPerRow[1]); 
  }
  var _currentLayout=getWindowLayout();

  if ($.inArray(perRow, _currentLayout)==-1) {
    perRow=_currentLayout[0];
  } 

  if (isNext===true) {
    perRow=_currentLayout[($.inArray(perRow, _currentLayout) + 1) % _currentLayout.length];
    setCookie("perrow",perRow);     
  }

  if(currentPerRow!=null) {     
    $('.filter-switch__grid').removeClass("filter-switch__grid--show"+currentPerRow[1]);   
    //$('.collection .col').removeClass("show"+currentPerRow[1]);   
  }
  $('.filter-switch__grid').addClass("filter-switch__grid--show"+perRow);  

  $('.collection .col').each(function() {
    var cn=this.className.match('xs-3');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-4');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-6');
    if (cn!=null) $(this).removeClass(cn[0]);
    var cn=this.className.match('xs-12');
    if (cn!=null) $(this).removeClass(cn[0]);
    var _classname="xs-3";
    switch(perRow) {
      case 1:      
      _classname="xs-12";
      break;
      case 2:
      _classname="xs-6";
      break;
      case 3:
      _classname="xs-4";
      break;
    }
    $(this).addClass(_classname);
  });
}

function layoutSwitch (isFirst) {
  if ($('.filter-switch').length>0) {
    switchLayout(isFirst);

    $('.filter-switch').off('click');
    $('.filter-switch').on('click',function() {
      switchLayout(false,true);
    });
  }
}
$(document).ready(function() {
  $(window).on('load resize', function() {
    layoutSwitch(true);
  });
});

//Header Sticky
var previousScroll = 0;
var headerOrgOffset =0;
if ($('.header').length>0)  headerOrgOffset =$('.header').offset().top-$(document).scrollTop();

$(window).off('scroll.header').on('scroll.header',function () {
  if ($('.header').length>0) {
    var currentScroll = $(this).scrollTop();
    if (currentScroll > headerOrgOffset) {
      if (currentScroll > previousScroll) {
        $('html:not(".no-scroll") .header').removeClass('header--sticky');
        //$('html:not(".no-scroll") .header-logo').removeClass('header-logo--sticky');
      } else {
        $('html:not(".no-scroll") .header').addClass('header--sticky');
        //$('html:not(".no-scroll") .header-logo').addClass('header-logo--sticky');
      }
    } else {
      $('html:not(".no-scroll") .header').removeClass('header--sticky');
      //$('html:not(".no-scroll") .header-logo').removeClass('header-logo--sticky');
    }
    previousScroll = currentScroll;
  }
});

// pnpHelper={};

// pnpHelper.nav = {
//   wasOpaque: !1,
//   down: function() {
//     $navBar.addClass("header--down");
//   },
//   up: function() {
//     $navBar.removeClass("header--down");
//   }, 
//   notTop: function() {
//     $navBar.addClass("header--scroll");
//   },
//   isTop: function() {
//     $navBar.removeClass("header--scroll");
//   },
// }
// pnpHelper.scroll = {
//   currentScrollTop: 0,
//   isLocked: !1,
//   scrollPast: function(a, b) {
//     if (b) var c = b; else var c = jQuery(a);
//     var d = c.offset().top + c.outerHeight(!0);
//     pnpHelper.scroll.doScroll(d);
//   },
//   scrollTo: function(a, b, c) {
//     var d = jQuery(a).offset().top;
//     "undefined" == typeof c && (c = 0), c && (d -= c), pnpHelper.scroll.doScroll(d, b);
//   },
//   doScroll: function(a, b) {
//     b || (b = null), "undefined" != typeof a && jQuery("html,body").animate({
//       scrollTop: a
//     }, 1e3, b);
//   },
// }

// jQuery(document).ready(function($) {
//   $navBar = $(".header");
//   function b() {
//     if (!pnpHelper.scroll.isLocked) {
//       var a = $(window).scrollTop();
//       a < g ? (pnpHelper.nav.isTop()) : (pnpHelper.nav.notTop()), d = a, c < d && a > f ? (pnpHelper.nav.down()) : c > d && !(a <= e) && pnpHelper.nav.up(), 
//       c = d;
//     }
//   }
//   var c, d = 0, e = $navBar.height(), f = 100, g = f;
//   window.addEventListener("scroll", function () { setTimeout(b, 50)}), b();
// });


// Filter Sticky
if ($(".filters")[0]) {
  var previousScrollFilter = 0,
  headerOrgOffsetFilter = $('.filters').offset().top + (-62);

  $(window).scroll(function (e) {
    var currentScrollFilter = $(this).scrollTop();
    if (currentScrollFilter > headerOrgOffsetFilter) {
      if (currentScrollFilter > previousScrollFilter) {
        $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
        $('html:not(".no-scroll") .header-logo').removeClass('header-logo--sticky');
      } else {
        $('html:not(".no-scroll") .filters__container').addClass('filters__container--sticky');
        $('html:not(".no-scroll") .header-logo').addClass('header-logo--sticky');
      }
    } else {
      $('html:not(".no-scroll") .filters__container').removeClass('filters__container--sticky');
      $('html:not(".no-scroll") .header-logo').removeClass('header-logo--sticky');
    }
    previousScrollFilter = currentScrollFilter;
  });
}

// Header Search Toggle
$(document).ready(function() {
  $('.header-search__toggle').click(function () {
    $('.header-search__form').toggleClass('header-search__form--visible');
    $('.site-container').toggleClass('site-container--blackout');
    $('.header').toggleClass('header--search-active');
    $('.header__wrap').toggleClass('header__wrap--search-active');
    $('.header-logo').toggleClass('header-logo--hide');
    $('.header-logo-mobile').toggleClass('header-logo-mobile--hide');
    $('.header-search__input').focus();
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".header *")) {
      $('.site-container').removeClass('site-container--blackout');
      $('.header-search__form').removeClass('header-search__form--visible');
      $('.header').removeClass('header--search-active');
      $('.header__wrap').removeClass('header__wrap--search-active');
      $('.header-logo').removeClass('header-logo--hide');
      $('.header-logo-mobile').removeClass('header-logo-mobile--hide');
    }
  });
});

// Share This BUtton
$(document).ready(function() {
  $('.product-add__share-wrap').click(function () {
    $('.product-add__share-popup').toggleClass('product-add__share-popup--active');
  });
  $(document).click(function (e) {
    if (!$(e.target).is(".product-add__share *")) {
      $('.product-add__share-popup').removeClass('product-add__share-popup--active');
    }
  });
});
$(document).ready(function() {
  $('.product-add__share-copy-icon').click(function () {
    $('.product-add__share-copy-icon').addClass('product-add__share-copy-icon--copied');
  });
});

// Share Button - Copy
$(document).ready(function(){
  var $temp = $("<input>");
  var $url = $(location).attr('href');
  $('#copy').click(function() {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
  });
});

// Mobile Menu
$(document).ready(function() { 
  if(jQuery().mmenu) {
    $("#my-menu").mmenu({
      // options
      "extensions": [
      "pagedim-white",
      "theme-light",
      ],
      "offCanvas": {
        "position": "left"
      },
      "navbar": {
        "add": true,
      },
    }, {
      // configuration
      clone: true,
      offCanvas: {
        pageSelector: ".site-container"
      }
    });
    var API = $("#my-menu").data( "mmenu" );

    $("#close-button").click(function() {
       API.close();
    });
  }
});

// Slick Carousels
function heroCarouselDesktop() {
  // Hero Carousel (Tablet/Desktop)
  $('.hero__carousel--desktop:not(.slick-initialized)').slick({
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        }
      },
    ]
  });
}

function heroCarouselMobile() {
  // Hero Carousel (Mobile Only)
  $('.hero__carousel--mobile:not(.slick-initialized)').slick({
    dots: true,
    arrows: false,
    infinite: true,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true
  });
}

function heroTextCarousel() {
  // Hero Text Carousel
  $('.hero-text__carousel:not(.slick-initialized)').slick({
    dots: true,
    infinite: true,
    lazyLoad: 'ondemand',
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 5000,
    pauseOnHover: true,
    pauseOnFocus: true,
    touchMove: true,
    slide: '.hero-text__banner',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrows: false,
        }
      }
    ]
  });
}

function promosCarousel() {
  // Promo Messages Carousel
  $('.promos__carousel:not(.slick-initialized)').slick({
    speed: 10000,
    autoplay: true,
    useAutoplayToggleButton: false,
    autoplaySpeed: 0,
    cssEase: 'linear',
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    arrows:false,
    pauseOnHover:false,
    infinite: true,
    pauseOnFocus:true
  }); 
} 

function trustpilotCarousel() {
  // TrustPilot Carousel
  $('.trustpilot__carousel:not(.slick-initialized)').slick({
    autoplay: true,
    autoplaySpeed: 5000,
    useAutoplayToggleButton: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:false,
    dots: true,
    pauseOnHover:true,
    infinite: true,
    pauseOnFocus:false
  }); 
} 

function featuredCollectionCarousel() {
  // Featured Collection Carousel
  $('.featured-collection__carousel:not(.slick-initialized)').slick({
    slidesToShow: 4,
    slidesToScroll: 4,
    dots: true,
    infinite: false,
    //slide: '.col',
    lazyLoad: 'ondemand',
    touchMove: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          arrows: false,
        }
      }
    ]
  });
}

function productFeaturedCarousel() {
  var slideWrapper = $(".product-images__featured-carousel"),
    iframes = slideWrapper.find('.product-images__embed-player'),
    lazyImages = slideWrapper.find('.product-images__featured-item'),
    lazyCounter = 0;

  // POST commands to YouTube or Vimeo API
  function postMessageToPlayer(player, command){
    if (player == null || command == null) return;
    player.contentWindow.postMessage(JSON.stringify(command), "*");
  }

  // When the slide is changing
  function playPauseVideo(slick, control){
    var currentSlide, slideType, startTime, player, video;

    currentSlide = slick.find(".slick-current");
    slideType = currentSlide.attr("class").split(" ")[1];
    player = currentSlide.find("iframe").get(0);
    startTime = currentSlide.data("video-start");

    if (slideType === "vimeo") {
      switch (control) {
        case "play":
          if ((startTime != null && startTime > 0 ) && !currentSlide.hasClass('started')) {
            currentSlide.addClass('started');
            postMessageToPlayer(player, {
              "method": "setCurrentTime",
              "value" : startTime
            });
          }
          postMessageToPlayer(player, {
            "method": "play",
            "value" : 1
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "method": "pause",
            "value": 1
          });
          break;
      }
    } else if (slideType === "youtube") {
      switch (control) {
        case "play":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "mute"
          });
          postMessageToPlayer(player, {
            "event": "command",
            "func": "playVideo"
          });
          break;
        case "pause":
          postMessageToPlayer(player, {
            "event": "command",
            "func": "pauseVideo"
          });
          break;
      }
    } else if (slideType === "video") {
      video = currentSlide.children("video").get(0);
      if (video != null) {
        if (control === "play"){
          video.play();
        } else {
          video.pause();
        }
      }
    }
  }

  // Resize player
  function resizePlayer(iframes, ratio) {
    if (!iframes[0]) return;
    var win = $(".product-images__featured-carousel"),
        width = win.width(),
        playerWidth,
        height = win.height(),
        playerHeight,
        ratio = ratio || 16/9;

    iframes.each(function(){
      var current = $(this);
      if (width / ratio < height) {
        playerWidth = Math.ceil(height * ratio);
        current.width(playerWidth).height(height).css({
          left: (width - playerWidth) / 2,
           top: 0
          });
      } else {
        playerHeight = Math.ceil(width / ratio);
        current.width(width).height(playerHeight).css({
          left: 0,
          top: (height - playerHeight) / 2
        });
      }
    });
  }

  // DOM Ready
  $(function() {
    // Initialize
    slideWrapper.on("init", function(slick){
      slick = $(slick.currentTarget);
      setTimeout(function(){
        playPauseVideo(slick,"play");
      }, 1000);
      resizePlayer(iframes, 16/9);
    });
    slideWrapper.on("beforeChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"pause");
    });
    slideWrapper.on("afterChange", function(event, slick) {
      slick = $(slick.$slider);
      playPauseVideo(slick,"play");
    });
    slideWrapper.on("lazyLoaded", function(event, slick, image, imageSource) {
      lazyCounter++;
      if (lazyCounter === lazyImages.length){
        lazyImages.addClass('show');
        // slideWrapper.slick("slickPlay");
      }
    });

    //start the slider
    slideWrapper.slick({
      // fade:true,
      autoplaySpeed:4000,
      // lazyLoad:"progressive",
      speed:600,
      arrows:false,
      dots: true,
      infinite: false,
      //cssEase:"cubic-bezier(0.87, 0.03, 0.41, 0.9)",
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1,
            arrows: false,
          }
        }
      ]
    });
  });

  // Resize event
  $(window).on("resize.slickVideoPlayer", function(){  
    resizePlayer(iframes, 16/9);
  });
}

function productThumbsCarousel() {
  // Change the main image whenever a thumbnail button is activated
  $('.product-images__thumbs-carousel').on('init', function(e, slider) {
    $(slider.$slides.find('.product-images__thumb-link')).each(function(index) {
      $(this).on('click', function() {
        // Move aria-current="true" to this button
        $(slider.$slides.find('.product-images__thumb-link').removeAttr('aria-current'));
        $(this).attr('aria-current', true);

        // Change the main image to match this thumbnail button
        var index = $(this).closest('.slick-slide').data('slick-index');
        $('.product-images__thumbs-carousel').slick('slickGoTo', index);
      });
    });
  });
  $('.product-images__thumbs-carousel:not(.slick-initialized)').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product-images__featured-carousel',
    dots: false,
    infinite: false,
    arrows: true,
    centerMode: false,
    vertical: true,
    focusOnSelect: true,
  
  });
}

// Product Page Zoom (Tablet / Desktop)
function zoomProduct() {
  $(window).on('shopify:section:load load resize orientationchange', function() {
    $('.product-images__featured-zoom').each(function(){
      if ($(window).width() > 766) {
        $('.product-images__featured-zoom').zoom({ 
          on:'click'
        });
      } else {
        $('.product-images__featured-zoom').trigger('zoom.destroy');
      }
    });
  });
}

// Swipebox
$(document).ready(function() { 
  if(jQuery().swipebox) {
    if ($(window).width() < 767) {
      $( '.swipebox' ).swipebox();
    }
  }
});

// Collection Description Toggle
$(document).ready(function() { 
  $('.collection__toggle').off('click').on('click', function () {
    $('.collection__description').slideToggle(200);
    $('.collection__show-hide').toggle();
    return false;
  });
});

// Footer Accordions
$(document).ready(function() { 
  $('.footer-content__accordion-header').off('click').on('click', function () {
    $(this).toggleClass('footer-content__accordion-header--shown');
    $(this).next('.footer-content__accordion-content').slideToggle(200);
    return false;
  });
});

// Cookie Notice
$(document).ready(function() { 
  $('.cookie-notice').cookieBar({
    'closeButton': '.cookie-notice__button',
  });
});

// Currency Converter
$(document).ready(function() { 
  $('.shopify-currency-form select').on('change', function() {
    $(this)
      .parents('form')
      .submit();
  });
});

// Size Convertor
$('.product-convertor__size').on('click', function () {
  $('.product-convertor__size').removeClass('product-convertor__size--active');
  $(this).addClass('product-convertor__size--active');
});

$('.product-convertor__size--uk').on('click', function () {
  $('.variant__element').each(function() {
    var currentlabel = $(this).attr('data-value');
    var newlabel = parseInt(currentlabel);
    if ($.isNumeric(currentlabel)) {
      $(this).children('.variant__label').children('span').text(newlabel);
    } else {
      $(this).children('.variant__label').children('span').text(currentlabel); 
    }
  });
});

$('.product-convertor__size--us').on('click', function () {
  $('.variant__element').each(function() {
    var currentlabel = $(this).attr('data-value');
    var newlabel = parseInt(currentlabel) + 2;
    if ($.isNumeric(currentlabel)) {
      $(this).children('.variant__label').children('span').text(newlabel);
    } else {
      $(this).children('.variant__label').children('span').text(newlabel); 
    }
  });
});

$('.product-convertor__size--euro').on('click', function () {
  $('.variant__element').each(function() {
    var currentlabel = $(this).attr('data-value');
    var newlabel = parseInt(currentlabel) + 33;
    if ($.isNumeric(currentlabel)) {
      $(this).children('.variant__label').children('span').text(newlabel);
     // debugger
    } else {
      //debugger
      $(this).children('.variant__label').children('span').text(newlabel); 
    }
  });
});

// Accordion
function productAccordion() { 
  var $tabs = $('.product-accordion');
  if ($tabs.length>0) {
  $tabs.responsiveTabs({
    rotate: false,
    startCollapsed: true,
    collapsible: 'accordion',
    animation: 'slide',
    duration: 300,
    setHash: false,
    disabled: [],
    classes: {
      stateDefault: '',
      stateActive: 'active',
      stateDisabled: '',
      stateExcluded: '',
      container: '',
      ul: 'product-accordion__nav',
      tab: '',
      anchor: 'product-accordion__anchor',
      panel: 'product-accordion__panel',
      accordionTitle: 'product-accordion__title'
    }
  });
  }
}

// Swatches
function initSwatches() {
  if (window.swatches!=undefined && document.location) {
    $('.swatches__col').off('mouseenter mouseleave');
    $('.swatches__col').off('click');
 
    if ($(window).width() > 599) {
    $('.swatches__col').hover(
      function(){
        const _id=$(this).data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else if (document.location.pathname.indexOf('products')==-1) {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
      },function(){
        const _id=$(this).parent().find("[class*='--current']").closest('a').data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  ==  _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
      }
    );
   }
   else {
     $('.swatches__col').on('click',function(e) {
        if ( $('div',this).hasClass('swatches__swatch--current')) return true;
        e.preventDefault();
        $(this).closest('.swatches').find('.swatches__swatch--current').removeClass('swatches__swatch--current');
        $('div',this).addClass('swatches__swatch--current');
        const _id=$(this).data('product-id');
        const _h=window.swatches.filter(function (e) { return (e.id  == _id )});
        if (_h.length>0) {                                                      
          showSwatchData(this,_h[0]);
        }
        else if (document.location.pathname.indexOf('products')==-1) {
          //swatch data not exist - need get firstly
          const el=this;
          var _handle;
          if (productsForFilter.length==0) {
            _handle=$(this).attr('href').replace('/products/','');
          }
          else {
            _handle=productsForFilter.filter(item => item.id === window.btoa('gid://shopify/Product/'+_id))[0].handle;
          }
          if (_handle!=undefined) {
            getSwatchData(_handle,function(h) {
              showSwatchData(el,this);
            });
          }
        }
       return false;
     });
 
   }
  }
}

function getSwatchData(_handle,callback) {     
  $.ajax({
      method    : 'GET',
      url       : document.location.origin+"/products/"+_handle+"/?view=swatch",        
      success: function (data) {
        var _d=data.replace(/\n/g,'').replace(/,}/g,'}');   
        window.swatches=window.swatches || [];
        const h=JSON.parse(_d);
        window.swatches.push(h);
    callback.apply(h);
   }
});
}
function showSwatchData(el,h) {
  $(el).parent().parent().parent().find('.product-card__image').attr("src", h.image);
  $(el).parent().parent().find('.product-card__title').text(h.title);
  $(el).parent().parent().find('.product-card__sku span').text(h.sku);
  $(el).parent().parent().find('.product-card__price-current').text(h.price);
  $(el).parent().parent().find('.product-card__price').removeClass('product-card__price--on-sale');
  $(el).parent().parent().find('.product-card__price').addClass(h.onsale);
  $(el).parent().parent().find('.product-card__price-compare').text(h.pricecompare);
  $(el).parent().parent().find('.product-card__price-saving').html(h.saving);
  $(el).parent().parent().parent().find('.product-card__overlays').replaceWith(h.overlays); 
}

// Run Functions
function register() {
  heroCarouselDesktop();
  heroCarouselMobile();
  heroTextCarousel();
  promosCarousel();
  trustpilotCarousel();
  featuredCollectionCarousel();
  productFeaturedCarousel();
  trustpilotCarousel();
  productThumbsCarousel();
  zoomProduct();
  productAccordion();
}
$(document).ready(function(){
  register();
});

// For Theme Editor
document.addEventListener("shopify:section:load", function(event) {
  register();
});

// setTimeout(function() {
//   //debugger
//   var scondSrc = jQuery('.product-images__thumbs .slick-slide:nth-child(2) img').attr('src');
//   jQuery('.product-swatches .swatches__swatch span').css('background-image','url('+scondSrc+')')
// }, 2000);




